/***
 * 
 * 
 * 入驻端主需要更改本页面
 * 
 */
const API = {
    imgUrl: "http://obs.beifamall.com/", //图片地址
   
    name: "image", //上传图片的字段
    userLoginId: sessionStorage.getItem("userLoginId"), //上传图片带的头信息
    
    loadingFlag: false,
    // imgUpload: "https://test-api.beifamall.com/base/file/mgmt/addOneImage", //图片上传地址
    // requestUrl: "https://test-api.beifamall.com",
    // entryMerchant:"https://test-merchant.beifamall.com",

    requestUrl: "https://api.beifamall.com",
    entryMerchant:"https://merchant.beifamall.com",
    imgUpload: "https://api.beifamall.com/base/file/mgmt/addOneImage", //图片上传地址

};
export default API;


// WEBPACK FOOTER //
// ./src/api/api.js